

import { GuestSearch } from "@/components/Inputs/GuestSearch";
import { Guest } from "@/types/Guest";
import { useAppointmentGuest } from "@/providers/AppointmentGuestProvider";
import { useTranslations } from "next-intl";

type TCCCompanionsFilterProps = {
  value: string;
  onChangeValue: (value: string | string[]) => void;
  onBlurAction?: () => void;
  border?: string;
  height?: string;
  fontSize?: string;
  surface?: string;
  padding?: string;
  rounded?: string;
};

export const TCCCompanionsFilter: React.FC<TCCCompanionsFilterProps> = ({
  value,
  onChangeValue,
  onBlurAction,
  border,
  height,
  fontSize,
  surface,
  padding,
  rounded,
}) => {
  const { getRelevantGuestName } = useAppointmentGuest();
  const t = useTranslations("inputColumnComponent");

  const defaultValue = value
    ? getRelevantGuestName(value, true)
    : "";

  return (
    <GuestSearch
      isFilter={true}
      mainGuestOnly={true}
      placeholder={t("searchGuest")}
      // Match the other filter value cells (e.g. TCCString) which wrap in
      // `flex-1`. GuestSearch defaults to `w-full`, which in the filter row's
      // flexbox collapses the field-name column (InputColumn, also flex-1) to
      // ~0 width — hiding the selected field label ("Verknüpfung").
      width="flex-1 min-w-0"
      defaultValue={defaultValue}
      border={border}
      height={height}
      fontSize={fontSize}
      surface={surface}
      padding={padding}
      rounded={rounded}
      setSelectedGuest={(guest: Guest | null) => {
        if (guest?.guestId) {
          onChangeValue(guest.guestId);
        } else {
          onChangeValue("");
        }
      }}
      onBlurAction={(guest: Guest | null) => {
        if (guest?.guestId) {
          onChangeValue(guest.guestId);
        } else if (!value) {
          onBlurAction?.();
        }
      }}
    />
  );
};
